import React, { useEffect, useState } from "react";
import Tabs from "../../../../components/elements/Tabs";
import LinkedAccounts from "../../../../components/elements/tabContent/LinkedAccounts";
import ChnageEmail from "../../../../components/elements/tabContent/ChnageEmail";
import { useMutation, useQuery } from "@tanstack/react-query";
import {
  profileDetails,
  profileUpdate,
} from "../../../../services/ProfileService";
import Form from "../../../../components/form/Form";
import useForm from "../../../../hooks/useForm";
import PasswordSettings from "../../../../components/elements/tabContent/PasswordSettings";
import PublicProfile from "../../../../components/sections/front/accountsSettings/PublicProfile";
import ContactInfo from "../../../../components/sections/front/accountsSettings/ContactInfo";
import { t } from "i18next";

const AccountSettings = () => {
  const [selectedTabIndex, setSelectedTabIndex] = useState(0);

  const tabItems = [
    {
      label: t("Contact Info"),
      icon: "fa-regular fa-address-card",
      content: <ContactInfo />,
    },
    // {
    //   label: "Change Email",
    //   icon: "fa-regular fa-envelope",
    //   content: (
    //     <ChnageEmail
    //       data={profileData?.data || {}}
    //       {...{ values, handleChange, errors, setFieldsValue }}
    //     />
    //   ),
    // },
    {
      label: t("Password"),
      icon: "fa-regular fa-lock",
      content: <PasswordSettings />,
    },
    {
      label: t("Public Profile"),
      icon: "fa-regular fa-address-card",
      content: <PublicProfile />,
    },
    // {
    //   label: "Linked Accounts",
    //   icon: "fa-regular fa-link",
    //   content: (
    //     <LinkedAccounts
    //       data={profileData?.data || {}}
    //       {...{ values, handleChange, errors, setFieldsValue }}
    //     />
    //   ),
    // },
    // {
    //   label: "Close Account",
    //   icon: "fa-regular fa-user-xmark",
    //   content: <></>,
    // },
  ];

  return (
    <div className="w-full relative flex items-start">
      <Tabs
        items={tabItems}
        selectedIndex={selectedTabIndex}
        setSelectedIndex={setSelectedTabIndex}
        tabButtonClass="w-full text-deep-purple bg-transparent hover:bg-primary/10 rounded-md shadow-none font-medium text-sm"
        tabClass={"font-normal"}
        tabsClass="bg-white w-full lg:w-52 xl:w-72 rounded-md shadow-sm px-3 lg:px-4 py-3 lg:py-6 lg:space-y-2 lg:h-[calc(100vh-8rem)] sticky top-28 overflow-y-auto scrollbar scrollbar-1"
        contentClass="px-0"
        type={"menu"}
        activeTabClass={"!bg-primary !text-white"}
        tablistsClass="w-full lg:w-auto"
        tabWrapperClass="flex-col lg:flex-row"
      />
    </div>
  );
};

export default AccountSettings;
